import Button from './markupComponents/Button';
import ContentImage from './markupComponents/ContentImage';
import Html from './markupComponents/Html';
import MarkupImage from './markupComponents/MarkupImage';
import NewsletterSignup from './markupComponents/NewsletterSignup';
import Select from './markupComponents/Select';
import Spacer from './markupComponents/Spacer';

const blokResolvers = {
  Button,
  ContentImage,
  Html,
  MarkupImage,
  NewsletterSignup,
  Select,
  Spacer,
};

export default blokResolvers;
